var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusRegularBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_372_837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1071 5.99977C11.1071 6.31148 10.8444 6.56227 10.5178 6.56227H6.58925V10.3123C6.58925 10.6228 6.3253 10.875 5.99997 10.875C5.67463 10.875 5.41068 10.624 5.41068 10.3123V6.56227H1.48211C1.15677 6.56227 0.892822 6.31055 0.892822 6C0.892822 5.69039 1.15677 5.43727 1.48211 5.43727H5.41068V1.68727C5.41068 1.37672 5.67463 1.125 5.99997 1.125C6.3253 1.125 6.58925 1.37672 6.58925 1.68727V5.43727H10.5178C10.8444 5.43727 11.1071 5.69039 11.1071 5.99977Z",
    fill: "#0E7490"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_372_837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRegularBrand);
export default __webpack_public_path__ + "static/media/plus-regular-brand.74b3aa621366a3ece8282f5a3271db66.svg";
export { ForwardRef as ReactComponent };